import React from 'react';

type CollapseHeaderForSectionsProps = {
  title: React.ReactNode;
  style?: React.CSSProperties;
};
const CollapseHeaderForSections = ({
  title,
  style,
}: CollapseHeaderForSectionsProps) => {
  return (
    <h3 className="clinical-obs__gene-section-title" style={style}>
      {title}
    </h3>
  );
};

export default CollapseHeaderForSections;
